import React, {useContext, useState} from "react";
import {injectIntl} from "react-intl";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE, TESSERACT_ASSET_TYPE} from "../../../util/Constants";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import {getLocalizedMessage} from "../../../util/Localization";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Input from "@amzn/meridian/input";
import {checkModalValidationsForConfig, isValidEntry, PATTERNS} from "../../../util/Validations";
import Alert from "@amzn/meridian/alert";
import Button from "@amzn/meridian/button";

const AddTesseractStowConfigurationModal = (props) => {

    const {mac, intl} = props;
    const {getDraftData, addInstance, editInstance} = useContext(DraftContext)

    // Visual controls
    const {open, setOpen} = props
    const [show, setShow] = useState(false)
    const [edit, setEdit] = useState(false)

    // Values
    const [containerType, setContainerType] = useState("")
    const [containerLabel, setContainerLabel] = useState("")

    // Error
    const [containerTypeErr, setContainerTypeErr] = useState(false)
    const [containerLabelErr, setContainerLabelErr] = useState(false)

    const stowConfig = {
        containerType: containerType,
        containerLabel: containerLabel
    }

    const stowConfigMap = {}
    getDraftData({stateKey: CONFIG_TYPE.TESSERACT_STOW_CONFIGURATION, subKey: mac}).forEach(value => {
        stowConfigMap[value.containerType] = {
            containerLabel: value.containerLabel
        }
    });

    function resetInputState() {
        setContainerType("")
        resetConfigDetails()
    }

    function resetConfigDetails() {
        setContainerLabel("")
    }

    function resetConfigErrorDetails() {
        setContainerLabelErr(false)
    }

    const prefill = () => {
        if(stowConfigMap.hasOwnProperty(containerType)) {
            setEdit(true)
            resetConfigErrorDetails()
            setContainerLabel(stowConfigMap[containerType].containerLabel)
        } else {
            setEdit(false)
            resetConfigDetails()
        }
    }

    const onCloseModal = () => {
        setShow(false);
        setOpen(false)
        resetInputState();
    }

    const onClickConfirm = (stowConfig, mac) => {
        const confirm = checkModalValidationsForConfig(stowConfig, mac, TESSERACT_ASSET_TYPE);
        if (confirm) {
            setConfigData(stowConfig, mac);
            setOpen(false)
            resetInputState();
            setShow(false);
        } else {
            setShow(true)
        }
    }

    const setConfigData = (stowConfig, mac) => {
        if (edit) {
            editInstance({
                stateKey: CONFIG_TYPE.TESSERACT_STOW_CONFIGURATION,
                subKey: mac,
                instance: stowConfig,
                keyComparator: (config1, config2) => (
                    config1.containerType === config2.containerType
                ),
                valueComparator: (config1, config2) => (
                    config1.containerLabel === config2.containerLabel
                )
            })
        } else {
            addInstance({
                stateKey: CONFIG_TYPE.TESSERACT_STOW_CONFIGURATION,
                subKey: mac,
                instance: stowConfig
            })
        }
    }

    return (
        <Row>
            <Modal
                title={getLocalizedMessage({intl, stringId: "stowconfig.addupdate"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Column spacing="200">
                        <b>{getLocalizedMessage({intl, stringId: "modal.tesseract_headingconfig"})}</b>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({intl, stringId: "container.type"})}
                        </Text>
                        <Input id="container-type-input"
                               value={containerType}
                               onChange={setContainerType}
                               onBlur={() => {
                                   setContainerTypeErr(!isValidEntry(containerType, PATTERNS.CONTAINER_TYPE))
                                   prefill();
                               }}
                               error={containerTypeErr}
                               helperText={getLocalizedMessage({intl, stringId:"modal.tesseract_containerType_description"})}/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({intl, stringId: "container.label"})}
                        </Text>
                        <Input id="container-label-input"
                               value={containerLabel}
                               onChange={setContainerLabel}
                               onBlur={() => {
                                   setContainerLabelErr(!isValidEntry(containerLabel, PATTERNS.CONTAINER_LABEL))
                               }}
                               error={containerLabelErr}
                               helperText={getLocalizedMessage({intl, stringId:"modal.tesseract_containerLabel_description"})}/>
                    </Column>
                </Column>
                <ModalFooter>
                    <Column>
                        {!checkModalValidationsForConfig(stowConfig, mac, TESSERACT_ASSET_TYPE) &&
                            show &&
                            <Alert type="warning" size="small">
                                {getLocalizedMessage({intl, stringId: "alert.missingfields"})}
                            </Alert>
                        }
                    </Column>
                    <Column spacing="200">
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="medium" onClick={onCloseModal}>
                                {getLocalizedMessage({intl, stringId: "modal.cancel"})}
                            </Button>
                            <Button type="primary" size="medium"
                                    onClick={() => onClickConfirm(stowConfig, mac)}>
                                {edit ? getLocalizedMessage({intl, stringId: "modal.confirmUpdate"})
                                    : getLocalizedMessage({intl, stringId: "modal.confirmAdd"})}
                            </Button>
                        </Row>
                    </Column>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddTesseractStowConfigurationModal)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/tesseract/modal/AddTesseractStowConfigurationModal.js